import React from 'react';
import clsx from 'clsx';

/**
 * Container component for consistent max-width and padding
 * Sizes: sm, md, lg, xl, full
 */
export function Container({
    children,
    size = 'lg',
    className,
    noPadding = false
}) {
    const sizeClasses = {
        sm: 'max-w-3xl',
        md: 'max-w-5xl',
        lg: 'max-w-6xl',
        xl: 'max-w-7xl',
        '2xl': 'max-w-[1400px]',
        full: 'max-w-full'
    };

    const paddingClasses = !noPadding && 'px-4 sm:px-6 lg:px-8';

    return (
        <div className={clsx('mx-auto w-full', sizeClasses[size], paddingClasses, className)}>
            {children}
        </div>
    );
}

/**
 * Section component for consistent vertical spacing
 */
export function Section({
    children,
    className,
    spacing = 'md'
}) {
    const spacingClasses = {
        sm: 'py-8',
        md: 'py-12',
        lg: 'py-16',
        xl: 'py-24'
    };

    return (
        <section className={clsx(spacingClasses[spacing], className)}>
            {children}
        </section>
    );
}

export default Container;
